/* global google:true */
var youbora = require('youboralib');

var manifest = require('../../manifest.json');

var ImaAdsAdapter = youbora.Adapter.extend({
  getVersion: function getVersion() {
    return manifest.version + '-videojs-ima-ads';
  },
  getDuration: function getDuration() {
    if (this.player.ima.getAdsManager() && this.player.ima.getAdsManager().getCurrentAd() !== null) {
      this.duration = this.player.ima.getAdsManager().getCurrentAd().getDuration();
    }

    return this.duration;
  },
  // NOT AVAILABLE AT adStart
  getResource: function getResource() {
    var manager = this.player.ima.getAdsManager();
    return manager ? manager.getCurrentAd().getMediaUrl() : null;
  },
  getTitle: function getTitle() {
    var manager = this.player.ima.getAdsManager();
    return manager ? manager.getCurrentAd().getTitle() : null;
  },
  getPlayhead: function getPlayhead() {
    var manager = this.player.ima.getAdsManager();
    return manager ? this.getDuration() - manager.getRemainingTime() : null;
  },
  getPlayerVersion: function getPlayerVersion() {
    return 'IMA' + google.ima.VERSION + '; contrib-ads ' + this.player.ads.VERSION;
  },
  getPosition: function getPosition() {
    if (this.plugin._adapter.getDuration() - 1 < this.plugin._adapter.getPlayhead()) {
      return youbora.Constants.AdPosition.Postroll;
    } else if (this.plugin._adapter.flags.isJoined) {
      return youbora.Constants.AdPosition.Midroll;
    }

    return youbora.Constants.AdPosition.Preroll;
  },
  getGivenBreaks: function getGivenBreaks() {
    if (!this.cuepoints) return null;
    return this.cuepoints.length;
  },
  getBreaksTime: function getBreaksTime() {
    return this.cuepoints;
  },
  getGivenAds: function getGivenAds() {
    return this.totalAds;
  },
  getAudioEnabled: function getAudioEnabled() {
    return !this.player.ima.adMuted;
  },
  getIsSkippable: function getIsSkippable() {
    return this.isSkippable;
  },
  getIsFullscreen: function getIsFullscreen() {
    var container = this.player.ima.adDisplayContainer;

    for (var index in container) {
      if (container[index] && container[index].width && container[index].height) {
        if (window.innerHeight && window.innerWidth && container[index].width && container[index].height) {
          return window.innerHeight <= container[index].height + 30 && window.innerWidth <= container[index].width + 30;
        }
      }
    }

    return false;
  },
  getIsVisible: function getIsVisible() {
    return youbora.Util.calculateAdViewability(this.player.ima.adContainerDiv);
  },
  registerListeners: function registerListeners() {
    // Enable playhead monitor
    this.monitorPlayhead(true, false); // Shortcut events

    var event = google.ima.AdEvent.Type; // Console all events if logLevel=DEBUG

    youbora.Util.logAllEvents(this.player.ima.addEventListener, [null, event.ALL_ADS_COMPLETED, event.LINEAR_CHANGED, event.USER_CLOSE, event.COMPLETE, event.IMPRESSION, event.CONTENT_PAUSE_REQUESTED, event.CONTENT_RESUME_REQUESTED, event.SKIPPED, event.SKIPPABLE_STATE_CHANGED, event.LOADED, event.PAUSED, event.RESUMED, event.STARTED, event.AD_CAN_PLAY, event.AD_METADATA, event.EXPANDED_CHANGED, event.AD_BREAK_READY, event.LOG, event.CLICK, google.ima.AdErrorEvent.Type.AD_ERROR]); // Register listeners

    this.references = [];
    this.references[event.AD_METADATA] = this.metadataListener.bind(this);
    this.references[event.LOADED] = this.loadedListener.bind(this);
    this.references[event.CONTENT_PAUSE_REQUESTED] = this.contentPauseRequestedListener.bind(this);
    this.references[event.STARTED] = this.startedListener.bind(this);
    this.references[event.PAUSED] = this.pausedListener.bind(this);
    this.references[event.RESUMED] = this.resumedListener.bind(this);
    this.references[event.COMPLETE] = this.completeListener.bind(this);
    this.references[event.SKIPPED] = this.skippedListener.bind(this);
    this.references[event.CLICK] = this.clickListener.bind(this);
    this.references[google.ima.AdErrorEvent.Type.AD_ERROR] = this.errorListener.bind(this);
    this.references[event.ALL_ADS_COMPLETED] = this.adsEndedListener.bind(this);
    this.references[event.FIRST_QUARTILE] = this.firstQuartileListener.bind(this);
    this.references[event.MIDPOINT] = this.secondQuartileListener.bind(this);
    this.references[event.THIRD_QUARTILE] = this.thirdQuartileListener.bind(this);
    this.playerReferences = [];
    this.playerReferences['adend'] = this.adEndedListener.bind(this);

    if (this.player && this.player.ima) {
      Object.keys(this.references).forEach(function (key) {
        this.player.ima.addEventListener(key, this.references[key]);
      }.bind(this));
      Object.keys(this.playerReferences).forEach(function (key) {
        this.player.on(key, this.playerReferences[key]);
      }.bind(this));
    }
  },
  metadataListener: function metadataListener(e) {
    this.cuepoints = e.getAdCuePoints().h.slice();

    if (this.plugin._adapter) {
      this.cuepoints.forEach(function (value, index) {
        if (this.cuepoints[index] === -1 || this.cuepoints[index] == null || this.cuepoints[index] === undefined) {
          this.cuepoints[index] = this.plugin._adapter.getDuration();
        }
      }.bind(this));
    }
  },
  loadedListener: function loadedListener(e) {
    this.isSkippable = e.getAdData().skippable;
    this.totalAds = e.getAdData().adPodInfo.totalAds;
    this.fireStart();
  },
  contentPauseRequestedListener: function contentPauseRequestedListener(e) {
    this.fireStart();
  },
  startedListener: function startedListener(e) {
    this.fireStart();
    this.fireJoin();
  },
  pausedListener: function pausedListener(e) {
    this.firePause();
  },
  resumedListener: function resumedListener(e) {
    this.fireResume();
  },
  completeListener: function completeListener(e) {
    this.fireStop();
  },
  skippedListener: function skippedListener(e) {
    this.fireStop({
      skipped: true
    });
  },
  adEndedListener: function adEndedListener(e) {
    this.fireStop();
  },
  errorListener: function errorListener(e) {
    var error = e.getError();
    this.fireError(error.getCode(), error.getMessage());
  },
  clickListener: function clickListener(e) {
    this.fireClick();
  },
  adsEndedListener: function adsEndedListener(e) {
    this.plugin.getAdapter().adsEnded = true;
    this.fireStop();
    if (this.plugin.requestBuilder.lastSent.adPosition === youbora.Constants.AdPosition.Postroll) this.plugin.fireStop();
  },
  firstQuartileListener: function firstQuartileListener(e) {
    this.fireQuartile(1);
  },
  secondQuartileListener: function secondQuartileListener(e) {
    this.fireQuartile(2);
  },
  thirdQuartileListener: function thirdQuartileListener(e) {
    this.fireQuartile(3);
  },
  unregisterListeners: function unregisterListeners() {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop(); // unregister listeners

    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) {
        this.player.ima.removeEventListener(key, this.references[key]);
      }.bind(this));
      if (this.player.ima) Object.keys(this.playerReferences).forEach(function (key) {
        this.player.off(key, this.playerReferences[key]);
      }.bind(this));
    }

    this.references = [];
    this.playerReferences = [];
  },
  adPlayerErrorListener: function adPlayerErrorListener(e) {
    var error = e.data.AdError; // https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdError

    var noResponseErrors = [1012, // There was a problem requesting ads from the server.
    301, // The VAST URI provided, or a VAST URI provided in a subsequent wrapper element,
    // was either unavailable or reached a timeout, as defined by the video player. The timeout is 5 seconds for initial VAST requests and each subsequent wrapper.
    402, // Failed to load media assets from a VAST response.
    302 // The maximum number of VAST wrapper redirects has been reached.
    ];
    var emptyResponse = [1007, // No assets were found in the VAST ad response
    1009, // Empty VAST response
    303 // No Ads VAST response after one or more wrappers
    ];
    var wrongResponse = [403, // Assets were found in the VAST ad response for linear ad, but none of them matched the video player's capabilities
    100, // The ad response was not recognized as a valid VAST ad
    503, // Assets were found in the VAST ad response for nonlinear ad, but none of them matched the video player's capabilities
    101, // VAST schema validation error.
    102 // The ad response contained an unsupported VAST version
    ];

    if (noResponseErrors.indexOf(error.getErrorCode()) >= 0) {
      this.fireManifest(youbora.Constants.ManifestError.NO_RESPONSE, error.getMessage());
    }

    if (emptyResponse.indexOf(error.getErrorCode()) >= 0) {
      this.fireManifest(youbora.Constants.ManifestError.EMPTY, error.getMessage());
    }

    if (wrongResponse.indexOf(error.getErrorCode()) >= 0) {
      this.fireManifest(youbora.Constants.ManifestError.WRONG, error.getMessage());
    }
  }
}, // Static Members
{
  isUsed: function isUsed(plugin) {
    return plugin.player.ima;
  }
});
module.exports = ImaAdsAdapter;